<template>
  <div style="width: auto; margin-right: auto; margin-left: auto">
    <h4 class="titulo" style="text-align: center;">Escanea Un Codigo</h4>
    <video id="videoScan" ref="video" style="width: 100%; max-width: 90vw; "></video>
<!--    <input v-model="result" placeholder="Código escaneado" />-->

  </div>
</template>

<script >
import { ref, onMounted, onBeforeUnmount } from 'vue'
import {  BrowserMultiFormatReader, BrowserQRCodeReader , BarcodeFormat, BrowserAztecCodeReader, BrowserMultiFormatOneDReader } from '@zxing/browser'

import { DecodeHintType } from '@zxing/library'

let codeReader

// const result = ref('')



export default {
  name: "inputScan",
  data(){
    return {
      result : '',
      video: null,
      codeReaderControls: null
    }
  },
  unmounted() {
    this.$nextTick(() => {

      if (this.codeReaderControls) {
        this.codeReaderControls.stop()
        this.codeReaderControls = null
      }
    })
  },
  methods:{
    scan(){


    }
  },

  mounted(){
    this.$nextTick(()=>{

      navigator.permissions.query({ name: 'camera' })
          .then(result => {
            console.log('Estado de la cámara:', result.state) // 'granted', 'denied', 'prompt'
            if (result.state === 'granted') {

              // Ya tiene permiso, puedes iniciar el escáner directamente
            } else if (result.state === 'prompt') {

              navigator.mediaDevices.getUserMedia({ video: true })
            } else {
              // 'denied' - el usuario bloqueó el acceso

            }
          })
          .catch(err => {
            console.error('No se pudo consultar permisos:', err)
          })


      codeReader = new BrowserMultiFormatOneDReader()
      this.video = document.getElementById('videoScan')

      codeReader.decodeFromVideoDevice(
          null, // usar cámara predeterminada
          this.video,
          (res, err, controls) => {

            if(err){
              console.log(err)
              // controls.stop()
            }
            if (res) {
              console.log(res)
              this.$emit('onScan', res)
              // this.result.value = res.getText()
              controls.stop()
            }
            if(!this.codeReaderControls) this.codeReaderControls = controls
          }
      ).catch(err => {
        console.error('Error al acceder a la cámara:', err)
      })


    })
  }
}
</script>

<style scoped>

.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto", serif;
  font-weight: lighter;
}

</style>



